
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7353"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7353"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("70ZUm", function(module, exports) {

$parcel$export(module.exports, "API_BASE", function () { return $51b88e288cab342b$export$d43f2f435f160490; });
$parcel$export(module.exports, "TYPESENSE_SERVER", function () { return $51b88e288cab342b$export$af866aed654b0406; });
const $51b88e288cab342b$var$IS_DEVELOPMENT = false;
function $51b88e288cab342b$var$buildTypesenseNode() {
    if ($51b88e288cab342b$var$IS_DEVELOPMENT) return {
        host: "localhost",
        port: "8108",
        protocol: "http"
    };
    const { hostname: hostname, port: port, protocol: protocol } = window.location;
    return {
        host: hostname,
        port: port || (protocol === "https:" ? "443" : "80"),
        protocol: protocol.replace(":", ""),
        path: "/typesense"
    };
}
const $51b88e288cab342b$export$4b749d8130c057c8 = $51b88e288cab342b$var$IS_DEVELOPMENT ? "http://localhost:3001" : window.location.origin;
const $51b88e288cab342b$export$d43f2f435f160490 = $51b88e288cab342b$var$IS_DEVELOPMENT ? `${$51b88e288cab342b$export$4b749d8130c057c8}/api` : "/api";
const $51b88e288cab342b$export$af866aed654b0406 = {
    apiKey: "xyz",
    nodes: [
        $51b88e288cab342b$var$buildTypesenseNode()
    ]
};

});


var $70ZUm = parcelRequire("70ZUm");
const $2fa64e9a31ed5d12$var$elements = {
    archiveButton: document.querySelector("#archive-button"),
    contextRecordDescription: document.querySelector("#context-record-description"),
    contextRecordIndex: document.querySelector("#context-record-index"),
    contextRecordName: document.querySelector("#context-record-name"),
    contextRecordStatus: document.querySelector("#context-record-status"),
    coverPreview: document.querySelector("#cover-preview"),
    coverUpload: document.querySelector("#cover-upload"),
    deleteButton: document.querySelector("#delete-button"),
    draftButton: document.querySelector("#draft-button"),
    editorContextIndex: document.querySelector("#editor-context-index"),
    editorContextPublished: document.querySelector("#editor-context-published"),
    editorContextSave: document.querySelector("#editor-context-save"),
    editorContextUpdated: document.querySelector("#editor-context-updated"),
    editorTitle: document.querySelector("#editor-title"),
    fieldCategory: document.querySelector("#field-category"),
    fieldCountry: document.querySelector("#field-country"),
    fieldCoverImageUrl: document.querySelector("#field-cover-image-url"),
    fieldDescription: document.querySelector("#field-description"),
    fieldExternalUrl: document.querySelector("#field-external-url"),
    fieldName: document.querySelector("#field-name"),
    fieldRegion: document.querySelector("#field-region"),
    fieldScore: document.querySelector("#field-score"),
    fieldSource: document.querySelector("#field-source"),
    fieldTags: document.querySelector("#field-tags"),
    importButton: document.querySelector("#import-button"),
    importFile: document.querySelector("#import-file"),
    importStatus: document.querySelector("#import-status"),
    listSearch: document.querySelector("#list-search"),
    newRecordButton: document.querySelector("#new-record-button"),
    overviewActivity: document.querySelector("#overview-activity"),
    overviewSummary: document.querySelector("#overview-summary"),
    preview: document.querySelector("#record-preview"),
    publishButton: document.querySelector("#publish-button"),
    recordContextStatusText: document.querySelector("#record-context-status-text"),
    recordContextTitle: document.querySelector("#record-context-title"),
    recordId: document.querySelector("#record-id"),
    recordIndexState: document.querySelector("#record-index-state"),
    recordList: document.querySelector("#record-list"),
    recordPublishedAt: document.querySelector("#record-published-at"),
    recordSaveState: document.querySelector("#record-save-state"),
    recordStatus: document.querySelector("#record-status"),
    recordStatusBadge: document.querySelector("#record-status-badge"),
    recordSummary: document.querySelector("#record-summary"),
    recordUpdatedAt: document.querySelector("#record-updated-at"),
    recordVisibilityText: document.querySelector("#record-visibility-text"),
    saveButton: document.querySelector("#save-button"),
    statusFilter: document.querySelector("#status-filter"),
    toast: document.querySelector("#admin-toast"),
    uploadButton: document.querySelector("#upload-button"),
    workflowSteps: Array.from(document.querySelectorAll("[data-workflow-step]")),
    workspaceSummary: document.querySelector("#workspace-summary")
};
const $2fa64e9a31ed5d12$var$editor = new window.Quill("#editor", {
    theme: "snow",
    modules: {
        toolbar: [
            [
                {
                    header: [
                        2,
                        3,
                        false
                    ]
                }
            ],
            [
                "bold",
                "italic",
                "underline",
                "blockquote"
            ],
            [
                {
                    list: "ordered"
                },
                {
                    list: "bullet"
                }
            ],
            [
                "link"
            ],
            [
                "clean"
            ]
        ]
    }
});
const $2fa64e9a31ed5d12$var$state = {
    activeId: null,
    activeRecord: null,
    isDirty: false,
    lastPersistedSignature: "",
    listQuery: "",
    listStatus: "all",
    requestedId: new URLSearchParams(window.location.search).get("recordId"),
    summary: null,
    toastTimer: null
};
function $2fa64e9a31ed5d12$var$statusClassName(status) {
    return `status-badge status-badge--${status || "draft"}`;
}
function $2fa64e9a31ed5d12$var$titleizeStatus(status) {
    const value = String(status || "draft").trim();
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $2fa64e9a31ed5d12$var$formatDate(timestamp) {
    if (!timestamp) return "Not yet";
    return new Date(timestamp * 1000).toISOString().slice(0, 16).replace("T", " ");
}
function $2fa64e9a31ed5d12$var$splitTags(input) {
    return String(input || "").split(/[,\n|]/).map((item)=>item.trim()).filter(Boolean);
}
function $2fa64e9a31ed5d12$var$normalizeHtml(input) {
    const value = String(input || "").replace(/\s+/g, " ").trim();
    return value === "<p><br></p>" ? "" : value;
}
function $2fa64e9a31ed5d12$var$payloadSignature(payload) {
    return JSON.stringify({
        category: String(payload.category || "").trim(),
        contentHtml: $2fa64e9a31ed5d12$var$normalizeHtml(payload.contentHtml),
        country: String(payload.country || "").trim(),
        coverImageUrl: String(payload.coverImageUrl || "").trim(),
        descriptionPlain: String(payload.descriptionPlain || "").trim(),
        externalUrl: String(payload.externalUrl || "").trim(),
        name: String(payload.name || "").trim(),
        region: String(payload.region || "").trim(),
        score: Number(payload.score) || 0,
        source: String(payload.source || "").trim(),
        status: String(payload.status || "draft").trim(),
        tags: $2fa64e9a31ed5d12$var$splitTags(payload.tags || []).join("|")
    });
}
function $2fa64e9a31ed5d12$var$recordToPayload(record) {
    return {
        name: record.name,
        category: record.category,
        country: record.country,
        region: record.region,
        source: record.source,
        score: record.score,
        tags: record.tags || [],
        descriptionPlain: record.descriptionPlain || "",
        contentHtml: record.contentHtml || "",
        coverImageUrl: record.coverImageUrl || "",
        externalUrl: record.externalUrl || "",
        status: record.status || "draft"
    };
}
function $2fa64e9a31ed5d12$var$createSummaryMarkup(summary) {
    return `
    <div class="summary-chip"><span>All</span><strong>${summary.all}</strong></div>
    <div class="summary-chip"><span>Draft</span><strong>${summary.draft}</strong></div>
    <div class="summary-chip"><span>Published</span><strong>${summary.published}</strong></div>
    <div class="summary-chip"><span>Archived</span><strong>${summary.archived}</strong></div>
  `;
}
function $2fa64e9a31ed5d12$var$setText(element, value) {
    if (element) element.textContent = value;
}
function $2fa64e9a31ed5d12$var$setStatusBadge(element, status) {
    if (!element) return;
    element.className = $2fa64e9a31ed5d12$var$statusClassName(status);
    element.textContent = status;
}
function $2fa64e9a31ed5d12$var$setContextChip(element, text, tone = "muted") {
    if (!element) return;
    element.className = `context-chip context-chip--${tone}`;
    element.textContent = text;
}
function $2fa64e9a31ed5d12$var$summarizeRecord(payload) {
    const summary = payload.descriptionPlain || "Start a new draft or select an existing record to continue editing.";
    return summary.length > 120 ? `${summary.slice(0, 117)}...` : summary;
}
function $2fa64e9a31ed5d12$var$currentVisibility(status, isDirty) {
    if (status !== "published") return "Hidden until published";
    return isDirty ? "Published snapshot live, edits pending sync" : "Visible in search preview";
}
function $2fa64e9a31ed5d12$var$currentIndexTone(status, isDirty) {
    if (status !== "published") return {
        text: "Index hidden",
        tone: "muted"
    };
    if (isDirty) return {
        text: "Index out of sync",
        tone: "warning"
    };
    return {
        text: "Live in search",
        tone: "success"
    };
}
function $2fa64e9a31ed5d12$var$currentSaveTone(isDirty) {
    return isDirty ? {
        text: "Unsaved changes",
        tone: "warning"
    } : {
        text: "No pending changes",
        tone: "success"
    };
}
function $2fa64e9a31ed5d12$var$updateWorkflow(status, isDirty) {
    const mode = status === "published" ? "published" : "draft";
    $2fa64e9a31ed5d12$var$elements.workflowSteps.forEach((step)=>{
        step.classList.remove("is-active", "is-complete");
    });
    const createStep = $2fa64e9a31ed5d12$var$elements.workflowSteps.find((step)=>step.dataset.workflowStep === "create");
    const refineStep = $2fa64e9a31ed5d12$var$elements.workflowSteps.find((step)=>step.dataset.workflowStep === "refine");
    const publishStep = $2fa64e9a31ed5d12$var$elements.workflowSteps.find((step)=>step.dataset.workflowStep === "publish");
    const previewStep = $2fa64e9a31ed5d12$var$elements.workflowSteps.find((step)=>step.dataset.workflowStep === "preview");
    createStep?.classList.add("is-complete");
    if (mode === "draft") refineStep?.classList.add("is-active");
    else {
        refineStep?.classList.add("is-complete");
        publishStep?.classList.add("is-complete");
        previewStep?.classList.add(isDirty ? "is-active" : "is-complete");
    }
    if (mode === "draft" && !isDirty) publishStep?.classList.add("is-active");
}
function $2fa64e9a31ed5d12$var$collectFormPayload() {
    return {
        name: $2fa64e9a31ed5d12$var$elements.fieldName.value.trim(),
        category: $2fa64e9a31ed5d12$var$elements.fieldCategory.value.trim(),
        country: $2fa64e9a31ed5d12$var$elements.fieldCountry.value.trim(),
        region: $2fa64e9a31ed5d12$var$elements.fieldRegion.value.trim(),
        source: $2fa64e9a31ed5d12$var$elements.fieldSource.value.trim(),
        score: Number($2fa64e9a31ed5d12$var$elements.fieldScore.value) || 0,
        tags: $2fa64e9a31ed5d12$var$splitTags($2fa64e9a31ed5d12$var$elements.fieldTags.value),
        descriptionPlain: $2fa64e9a31ed5d12$var$elements.fieldDescription.value.trim(),
        contentHtml: $2fa64e9a31ed5d12$var$editor.root.innerHTML,
        coverImageUrl: $2fa64e9a31ed5d12$var$elements.fieldCoverImageUrl.value.trim(),
        externalUrl: $2fa64e9a31ed5d12$var$elements.fieldExternalUrl.value.trim(),
        status: $2fa64e9a31ed5d12$var$elements.recordStatus.value
    };
}
async function $2fa64e9a31ed5d12$var$request(path, options = {}) {
    const response = await fetch(`${(0, $70ZUm.API_BASE)}${path}`, {
        headers: {
            "Content-Type": "application/json",
            ...options.headers || {}
        },
        ...options
    });
    const isJson = response.headers.get("content-type")?.includes("application/json");
    const data = isJson ? await response.json() : await response.text();
    if (!response.ok) throw new Error(data.error || data || "Request failed");
    return data;
}
function $2fa64e9a31ed5d12$var$showToast(message) {
    clearTimeout($2fa64e9a31ed5d12$var$state.toastTimer);
    $2fa64e9a31ed5d12$var$elements.toast.hidden = false;
    $2fa64e9a31ed5d12$var$elements.toast.textContent = message;
    $2fa64e9a31ed5d12$var$state.toastTimer = window.setTimeout(()=>{
        $2fa64e9a31ed5d12$var$elements.toast.hidden = true;
    }, 2800);
}
function $2fa64e9a31ed5d12$var$emitRecordsChanged(reason, recordId = null) {
    window.dispatchEvent(new CustomEvent("records:changed", {
        detail: {
            reason: reason,
            recordId: recordId
        }
    }));
}
function $2fa64e9a31ed5d12$var$setStatus(status) {
    $2fa64e9a31ed5d12$var$elements.recordStatus.value = status;
    $2fa64e9a31ed5d12$var$setStatusBadge($2fa64e9a31ed5d12$var$elements.recordStatusBadge, status);
    $2fa64e9a31ed5d12$var$setStatusBadge($2fa64e9a31ed5d12$var$elements.contextRecordStatus, status);
}
function $2fa64e9a31ed5d12$var$syncUrl(recordId = null) {
    const url = new URL(window.location.href);
    if (recordId) {
        url.searchParams.set("recordId", recordId);
        if (!url.hash) url.hash = "records";
    } else url.searchParams.delete("recordId");
    window.history.replaceState({}, "", url);
}
function $2fa64e9a31ed5d12$var$renderSummary(summary) {
    const markup = $2fa64e9a31ed5d12$var$createSummaryMarkup(summary);
    $2fa64e9a31ed5d12$var$state.summary = summary;
    [
        $2fa64e9a31ed5d12$var$elements.recordSummary,
        $2fa64e9a31ed5d12$var$elements.overviewSummary,
        $2fa64e9a31ed5d12$var$elements.workspaceSummary
    ].forEach((element)=>{
        if (element) element.innerHTML = markup;
    });
}
function $2fa64e9a31ed5d12$var$renderActivity(items) {
    if (!$2fa64e9a31ed5d12$var$elements.overviewActivity) return;
    if (!items.length) {
        $2fa64e9a31ed5d12$var$elements.overviewActivity.innerHTML = `<div class="activity-item"><small>No recent activity yet.</small></div>`;
        return;
    }
    $2fa64e9a31ed5d12$var$elements.overviewActivity.innerHTML = items.slice(0, 4).map((record)=>`
        <button class="activity-item" type="button" data-record-item="${record.id}">
          <div class="activity-item__row">
            <strong>${record.name}</strong>
            <span class="${$2fa64e9a31ed5d12$var$statusClassName(record.status)}">${record.status}</span>
          </div>
          <small>${record.category} \xb7 ${record.country} \xb7 Updated ${$2fa64e9a31ed5d12$var$formatDate(record.updatedAt)}</small>
        </button>
      `).join("");
}
function $2fa64e9a31ed5d12$var$updateContextPanels() {
    const payload = $2fa64e9a31ed5d12$var$collectFormPayload();
    const status = payload.status || "draft";
    const displayName = payload.name || "New Record";
    const lastSaved = $2fa64e9a31ed5d12$var$formatDate($2fa64e9a31ed5d12$var$state.activeRecord?.updatedAt);
    const publishedAt = $2fa64e9a31ed5d12$var$formatDate($2fa64e9a31ed5d12$var$state.activeRecord?.publishedAt);
    const visibility = $2fa64e9a31ed5d12$var$currentVisibility(status, $2fa64e9a31ed5d12$var$state.isDirty);
    const saveState = $2fa64e9a31ed5d12$var$currentSaveTone($2fa64e9a31ed5d12$var$state.isDirty);
    const indexState = $2fa64e9a31ed5d12$var$currentIndexTone(status, $2fa64e9a31ed5d12$var$state.isDirty);
    $2fa64e9a31ed5d12$var$setText($2fa64e9a31ed5d12$var$elements.contextRecordName, displayName);
    $2fa64e9a31ed5d12$var$setText($2fa64e9a31ed5d12$var$elements.contextRecordDescription, $2fa64e9a31ed5d12$var$summarizeRecord(payload));
    $2fa64e9a31ed5d12$var$setText($2fa64e9a31ed5d12$var$elements.recordContextTitle, displayName);
    $2fa64e9a31ed5d12$var$setText($2fa64e9a31ed5d12$var$elements.recordContextStatusText, $2fa64e9a31ed5d12$var$titleizeStatus(status));
    $2fa64e9a31ed5d12$var$setText($2fa64e9a31ed5d12$var$elements.recordUpdatedAt, lastSaved);
    $2fa64e9a31ed5d12$var$setText($2fa64e9a31ed5d12$var$elements.recordVisibilityText, visibility);
    $2fa64e9a31ed5d12$var$setContextChip($2fa64e9a31ed5d12$var$elements.contextRecordIndex, indexState.text, indexState.tone);
    $2fa64e9a31ed5d12$var$setContextChip($2fa64e9a31ed5d12$var$elements.recordSaveState, saveState.text, saveState.tone);
    $2fa64e9a31ed5d12$var$setContextChip($2fa64e9a31ed5d12$var$elements.recordIndexState, indexState.text, indexState.tone);
    $2fa64e9a31ed5d12$var$setContextChip($2fa64e9a31ed5d12$var$elements.editorContextSave, saveState.text, saveState.tone);
    $2fa64e9a31ed5d12$var$setContextChip($2fa64e9a31ed5d12$var$elements.editorContextIndex, indexState.text, indexState.tone);
    $2fa64e9a31ed5d12$var$setContextChip($2fa64e9a31ed5d12$var$elements.editorContextUpdated, `Last saved: ${lastSaved}`, "muted");
    $2fa64e9a31ed5d12$var$setContextChip($2fa64e9a31ed5d12$var$elements.editorContextPublished, `Published: ${publishedAt}`, "muted");
    $2fa64e9a31ed5d12$var$setContextChip($2fa64e9a31ed5d12$var$elements.recordPublishedAt, `Published: ${publishedAt}`, "muted");
    $2fa64e9a31ed5d12$var$updateWorkflow(status, $2fa64e9a31ed5d12$var$state.isDirty);
}
function $2fa64e9a31ed5d12$var$updateDirtyState() {
    const nextSignature = $2fa64e9a31ed5d12$var$payloadSignature($2fa64e9a31ed5d12$var$collectFormPayload());
    $2fa64e9a31ed5d12$var$state.isDirty = nextSignature !== $2fa64e9a31ed5d12$var$state.lastPersistedSignature;
    $2fa64e9a31ed5d12$var$updateContextPanels();
}
function $2fa64e9a31ed5d12$var$renderPreview() {
    const payload = $2fa64e9a31ed5d12$var$collectFormPayload();
    const tags = payload.tags.map((tag)=>`<span>${tag}</span>`).join("");
    const coverStyle = payload.coverImageUrl ? `style="background-image: url('${payload.coverImageUrl}')"` : "";
    $2fa64e9a31ed5d12$var$elements.preview.innerHTML = `
    <article class="record-card">
      <div class="record-card__cover ${payload.coverImageUrl ? "has-image" : ""}" ${coverStyle}>
        <div class="record-card__cover-badge">${payload.category || "category"}</div>
      </div>
      <div class="record-card__body">
        <h2 class="record-card__title">${payload.name || "Untitled record"}</h2>
        <div class="record-card__meta">
          <span>${payload.country || "Country"}</span>
          <span>${payload.region || "Region"}</span>
        </div>
        <p class="record-card__description">${payload.descriptionPlain || "Summary preview will appear here."}</p>
        <div class="record-card__tags">${tags}</div>
        <div class="record-card__footer">
          <span>Source: ${payload.source || "manual_entry"}</span>
          <span>Status: ${payload.status}</span>
          <span>Score: ${payload.score}</span>
        </div>
      </div>
    </article>
  `;
    $2fa64e9a31ed5d12$var$elements.coverPreview.style.backgroundImage = payload.coverImageUrl ? `url('${payload.coverImageUrl}')` : "";
    $2fa64e9a31ed5d12$var$updateDirtyState();
}
function $2fa64e9a31ed5d12$var$fillForm(record) {
    $2fa64e9a31ed5d12$var$state.activeId = record.id;
    $2fa64e9a31ed5d12$var$state.activeRecord = record;
    $2fa64e9a31ed5d12$var$state.requestedId = record.id;
    $2fa64e9a31ed5d12$var$elements.recordId.value = record.id;
    $2fa64e9a31ed5d12$var$elements.editorTitle.textContent = record.name;
    $2fa64e9a31ed5d12$var$elements.fieldName.value = record.name;
    $2fa64e9a31ed5d12$var$elements.fieldCategory.value = record.category;
    $2fa64e9a31ed5d12$var$elements.fieldCountry.value = record.country;
    $2fa64e9a31ed5d12$var$elements.fieldRegion.value = record.region;
    $2fa64e9a31ed5d12$var$elements.fieldSource.value = record.source;
    $2fa64e9a31ed5d12$var$elements.fieldScore.value = record.score;
    $2fa64e9a31ed5d12$var$elements.fieldTags.value = (record.tags || []).join(", ");
    $2fa64e9a31ed5d12$var$elements.fieldDescription.value = record.descriptionPlain || "";
    $2fa64e9a31ed5d12$var$elements.fieldCoverImageUrl.value = record.coverImageUrl || "";
    $2fa64e9a31ed5d12$var$elements.fieldExternalUrl.value = record.externalUrl || "";
    $2fa64e9a31ed5d12$var$editor.root.innerHTML = record.contentHtml || "";
    $2fa64e9a31ed5d12$var$setStatus(record.status || "draft");
    $2fa64e9a31ed5d12$var$syncUrl(record.id);
    $2fa64e9a31ed5d12$var$state.lastPersistedSignature = $2fa64e9a31ed5d12$var$payloadSignature($2fa64e9a31ed5d12$var$recordToPayload(record));
    $2fa64e9a31ed5d12$var$state.isDirty = false;
    $2fa64e9a31ed5d12$var$renderPreview();
    $2fa64e9a31ed5d12$var$updateActionState();
}
function $2fa64e9a31ed5d12$var$resetForm() {
    $2fa64e9a31ed5d12$var$state.activeId = null;
    $2fa64e9a31ed5d12$var$state.activeRecord = null;
    $2fa64e9a31ed5d12$var$state.requestedId = null;
    $2fa64e9a31ed5d12$var$elements.recordId.value = "";
    $2fa64e9a31ed5d12$var$elements.editorTitle.textContent = "New Record";
    $2fa64e9a31ed5d12$var$elements.fieldName.value = "";
    $2fa64e9a31ed5d12$var$elements.fieldCategory.value = "";
    $2fa64e9a31ed5d12$var$elements.fieldCountry.value = "";
    $2fa64e9a31ed5d12$var$elements.fieldRegion.value = "";
    $2fa64e9a31ed5d12$var$elements.fieldSource.value = "manual_entry";
    $2fa64e9a31ed5d12$var$elements.fieldScore.value = "50";
    $2fa64e9a31ed5d12$var$elements.fieldTags.value = "";
    $2fa64e9a31ed5d12$var$elements.fieldDescription.value = "";
    $2fa64e9a31ed5d12$var$elements.fieldCoverImageUrl.value = "";
    $2fa64e9a31ed5d12$var$elements.fieldExternalUrl.value = "";
    $2fa64e9a31ed5d12$var$editor.root.innerHTML = "";
    $2fa64e9a31ed5d12$var$setStatus("draft");
    $2fa64e9a31ed5d12$var$syncUrl(null);
    $2fa64e9a31ed5d12$var$state.lastPersistedSignature = $2fa64e9a31ed5d12$var$payloadSignature($2fa64e9a31ed5d12$var$collectFormPayload());
    $2fa64e9a31ed5d12$var$state.isDirty = false;
    $2fa64e9a31ed5d12$var$renderPreview();
    $2fa64e9a31ed5d12$var$updateActionState();
}
function $2fa64e9a31ed5d12$var$renderRecordList(items) {
    if (!items.length) {
        $2fa64e9a31ed5d12$var$elements.recordList.innerHTML = `<div class="record-list__item">No records match the current filter.</div>`;
        return;
    }
    $2fa64e9a31ed5d12$var$elements.recordList.innerHTML = items.map((record)=>`
        <button class="record-list__item ${record.id === $2fa64e9a31ed5d12$var$state.activeId ? "is-active" : ""}" type="button" data-record-item="${record.id}">
          <div class="record-list__item-header">
            <div class="record-list__title">${record.name}</div>
            <span class="record-list__score">Score ${record.score}</span>
          </div>
          <div class="record-list__meta">
            <span>${record.category}</span>
            <span>${record.country}</span>
            <span>${record.region}</span>
          </div>
          <div class="record-list__meta">
            <span class="${$2fa64e9a31ed5d12$var$statusClassName(record.status)}">${record.status}</span>
            <span>${record.source}</span>
            <span>Updated ${$2fa64e9a31ed5d12$var$formatDate(record.updatedAt)}</span>
          </div>
        </button>
      `).join("");
}
async function $2fa64e9a31ed5d12$var$loadRecord(id) {
    const record = await $2fa64e9a31ed5d12$var$request(`/records/${id}`);
    $2fa64e9a31ed5d12$var$fillForm(record);
}
async function $2fa64e9a31ed5d12$var$loadRecords() {
    const result = await $2fa64e9a31ed5d12$var$request(`/records?status=${encodeURIComponent($2fa64e9a31ed5d12$var$state.listStatus)}&q=${encodeURIComponent($2fa64e9a31ed5d12$var$state.listQuery)}&limit=100`);
    $2fa64e9a31ed5d12$var$renderSummary(result.summary);
    $2fa64e9a31ed5d12$var$renderActivity(result.items);
    $2fa64e9a31ed5d12$var$renderRecordList(result.items);
    if ($2fa64e9a31ed5d12$var$state.activeId) {
        const stillExists = result.items.find((item)=>item.id === $2fa64e9a31ed5d12$var$state.activeId);
        if (!stillExists) $2fa64e9a31ed5d12$var$resetForm();
        return;
    }
    if ($2fa64e9a31ed5d12$var$state.requestedId) {
        const requestedRecord = result.items.find((item)=>item.id === $2fa64e9a31ed5d12$var$state.requestedId);
        if (requestedRecord) {
            await $2fa64e9a31ed5d12$var$loadRecord(requestedRecord.id);
            return;
        }
    }
    if (result.items[0]) await $2fa64e9a31ed5d12$var$loadRecord(result.items[0].id);
}
async function $2fa64e9a31ed5d12$var$saveRecord(nextStatus = null) {
    const payload = $2fa64e9a31ed5d12$var$collectFormPayload();
    payload.status = nextStatus || payload.status;
    const method = $2fa64e9a31ed5d12$var$state.activeId ? "PUT" : "POST";
    const path = $2fa64e9a31ed5d12$var$state.activeId ? `/records/${$2fa64e9a31ed5d12$var$state.activeId}` : "/records";
    const record = await $2fa64e9a31ed5d12$var$request(path, {
        method: method,
        body: JSON.stringify(payload)
    });
    $2fa64e9a31ed5d12$var$fillForm(record);
    await $2fa64e9a31ed5d12$var$loadRecords();
    $2fa64e9a31ed5d12$var$emitRecordsChanged(nextStatus || "saved", record.id);
    $2fa64e9a31ed5d12$var$showToast(nextStatus ? `Record moved to ${nextStatus}` : "Record saved");
}
async function $2fa64e9a31ed5d12$var$deleteActiveRecord() {
    if (!$2fa64e9a31ed5d12$var$state.activeId) return;
    if (!window.confirm("Delete this record permanently?")) return;
    await $2fa64e9a31ed5d12$var$request(`/records/${$2fa64e9a31ed5d12$var$state.activeId}`, {
        method: "DELETE"
    });
    $2fa64e9a31ed5d12$var$resetForm();
    await $2fa64e9a31ed5d12$var$loadRecords();
    $2fa64e9a31ed5d12$var$emitRecordsChanged("deleted");
    $2fa64e9a31ed5d12$var$showToast("Record deleted");
}
async function $2fa64e9a31ed5d12$var$uploadCover() {
    const file = $2fa64e9a31ed5d12$var$elements.coverUpload.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(`${(0, $70ZUm.API_BASE)}/uploads`, {
        method: "POST",
        body: formData
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Upload failed");
    $2fa64e9a31ed5d12$var$elements.fieldCoverImageUrl.value = data.url;
    $2fa64e9a31ed5d12$var$renderPreview();
    $2fa64e9a31ed5d12$var$showToast("Cover uploaded");
}
async function $2fa64e9a31ed5d12$var$importBatch() {
    const file = $2fa64e9a31ed5d12$var$elements.importFile.files[0];
    if (!file) throw new Error("Choose a JSON or CSV file first");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("status", $2fa64e9a31ed5d12$var$elements.importStatus.value);
    const response = await fetch(`${(0, $70ZUm.API_BASE)}/import`, {
        method: "POST",
        body: formData
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Import failed");
    await $2fa64e9a31ed5d12$var$loadRecords();
    $2fa64e9a31ed5d12$var$emitRecordsChanged("imported");
    $2fa64e9a31ed5d12$var$showToast(`Imported ${data.imported} records`);
}
function $2fa64e9a31ed5d12$var$updateActionState() {
    const hasRecord = Boolean($2fa64e9a31ed5d12$var$state.activeId);
    $2fa64e9a31ed5d12$var$elements.deleteButton.disabled = !hasRecord;
}
function $2fa64e9a31ed5d12$var$handleRecordSelection(event) {
    const button = event.target.closest("[data-record-item]");
    if (!button) return;
    $2fa64e9a31ed5d12$var$loadRecord(button.dataset.recordItem).then(()=>{
        window.dispatchEvent(new CustomEvent("workspace:navigate", {
            detail: {
                view: "records",
                tab: "editor"
            }
        }));
        return $2fa64e9a31ed5d12$var$loadRecords();
    }).catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
}
$2fa64e9a31ed5d12$var$elements.newRecordButton.addEventListener("click", ()=>{
    $2fa64e9a31ed5d12$var$resetForm();
});
$2fa64e9a31ed5d12$var$elements.saveButton.addEventListener("click", ()=>{
    $2fa64e9a31ed5d12$var$saveRecord().catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
});
$2fa64e9a31ed5d12$var$elements.publishButton.addEventListener("click", ()=>{
    $2fa64e9a31ed5d12$var$saveRecord("published").catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
});
$2fa64e9a31ed5d12$var$elements.draftButton.addEventListener("click", ()=>{
    $2fa64e9a31ed5d12$var$saveRecord("draft").catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
});
$2fa64e9a31ed5d12$var$elements.archiveButton.addEventListener("click", ()=>{
    $2fa64e9a31ed5d12$var$saveRecord("archived").catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
});
$2fa64e9a31ed5d12$var$elements.deleteButton.addEventListener("click", ()=>{
    $2fa64e9a31ed5d12$var$deleteActiveRecord().catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
});
$2fa64e9a31ed5d12$var$elements.uploadButton.addEventListener("click", ()=>{
    $2fa64e9a31ed5d12$var$uploadCover().catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
});
$2fa64e9a31ed5d12$var$elements.importButton.addEventListener("click", ()=>{
    $2fa64e9a31ed5d12$var$importBatch().catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
});
$2fa64e9a31ed5d12$var$elements.recordList.addEventListener("click", $2fa64e9a31ed5d12$var$handleRecordSelection);
$2fa64e9a31ed5d12$var$elements.overviewActivity?.addEventListener("click", $2fa64e9a31ed5d12$var$handleRecordSelection);
let $2fa64e9a31ed5d12$var$searchTimer = null;
$2fa64e9a31ed5d12$var$elements.listSearch.addEventListener("input", (event)=>{
    clearTimeout($2fa64e9a31ed5d12$var$searchTimer);
    $2fa64e9a31ed5d12$var$searchTimer = window.setTimeout(()=>{
        $2fa64e9a31ed5d12$var$state.listQuery = event.target.value.trim();
        $2fa64e9a31ed5d12$var$loadRecords().catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
    }, 180);
});
$2fa64e9a31ed5d12$var$elements.statusFilter.addEventListener("change", (event)=>{
    $2fa64e9a31ed5d12$var$state.listStatus = event.target.value;
    $2fa64e9a31ed5d12$var$loadRecords().catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));
});
[
    $2fa64e9a31ed5d12$var$elements.fieldName,
    $2fa64e9a31ed5d12$var$elements.fieldCategory,
    $2fa64e9a31ed5d12$var$elements.fieldCountry,
    $2fa64e9a31ed5d12$var$elements.fieldRegion,
    $2fa64e9a31ed5d12$var$elements.fieldSource,
    $2fa64e9a31ed5d12$var$elements.fieldScore,
    $2fa64e9a31ed5d12$var$elements.fieldTags,
    $2fa64e9a31ed5d12$var$elements.fieldDescription,
    $2fa64e9a31ed5d12$var$elements.fieldCoverImageUrl,
    $2fa64e9a31ed5d12$var$elements.fieldExternalUrl
].forEach((input)=>{
    input.addEventListener("input", $2fa64e9a31ed5d12$var$renderPreview);
});
$2fa64e9a31ed5d12$var$editor.on("text-change", $2fa64e9a31ed5d12$var$renderPreview);
window.addEventListener("beforeunload", (event)=>{
    if (!$2fa64e9a31ed5d12$var$state.isDirty) return;
    event.preventDefault();
    event.returnValue = "";
});
$2fa64e9a31ed5d12$var$resetForm();
$2fa64e9a31ed5d12$var$loadRecords().catch((error)=>$2fa64e9a31ed5d12$var$showToast(error.message));


//# sourceMappingURL=index.59151c6b.js.map
